import {useQuery} from 'react-query';
import {getAddressByTitleSearch} from '.';

const useGeAddressByTitleSearch = (filterValue: string) => {
  const {data: address, isLoading} = useQuery(
    ['get-location-address', filterValue],
    () => getAddressByTitleSearch(filterValue),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
  return {address, isLoading};
};

export default useGeAddressByTitleSearch;
